import { Button } from "components/ui/button";
import { useSetAtom } from "lib/global-context";
import { currentStepAtom } from "lib/atoms";
import { ChevronLeft } from "components/common/icons";
import styles from "./back-button.module.css";

const BackButton = () => {
  const setCurrentStep = useSetAtom(currentStepAtom);

  return (
    <Button
      onClick={() => setCurrentStep((prev) => prev - 1)}
      variant={"secondary"}
      size={"sm"}
      className={styles.button}
    >
      <ChevronLeft />
      Back
    </Button>
  );
};

export default BackButton;
